import { AlertTitleProps, AlertTitle as MuiAlertTitle } from '@material-ui/lab'
import React, { FC } from 'react'

import { Typography } from '@popmenu/common-ui'

export const AlertTitle: FC<AlertTitleProps> = (props) => {
  const { children, ...muiProps } = props
  return (
    <MuiAlertTitle {...muiProps}>
      <Typography variant="h6"> {children} </Typography>
    </MuiAlertTitle>
  )
}

AlertTitle.displayName = 'AlertTitle'
